import React from 'react';
import { cn } from '@/lib/utils';
import { getTemperatureRange, getHumidityRange } from '@/utils/environmentRanges';

interface ValueBadgeProps {
  value: number | null;
  unit: string;
  status?: string;
  className?: string;
  isAlarm: boolean;
  type?: 'temperature' | 'humidity';
}

export function ValueBadge({ value, isAlarm, unit, status, className, type }: ValueBadgeProps) {
  if (value === null || value === undefined) return <span className="text-dark-grey">-</span>;
  // Now we know value is a number (including 0)

  // Format the value to 1 decimal place
  const formattedValue = value.toFixed(1);

  // Determine color based on range if type is specified
  let rangeColor = '';
  if (type && !isAlarm) { // Only apply range colors if not in alarm state
    if (type === 'temperature') {
      const range = getTemperatureRange(value);
      if (range === 'LOW') rangeColor = 'text-dark-blue bg-[rgba(139,198,255,0.3)]'; // Light blue for cold
      if (range === 'HIGH') rangeColor = 'text-dark-orange bg-[rgba(234,102,63,0.2)]'; // Light red for hot
      if (range === 'NORMAL') rangeColor = 'text-dark-green bg-[rgba(89,209,206,0.2)]'; // Light green for normal
    } else if (type === 'humidity') {
      const range = getHumidityRange(value);
      if (range === 'LOW') rangeColor = 'text-mid-orange bg-[rgba(249,195,106,0.3)]'; // Light orange for low humidity
      if (range === 'HIGH') rangeColor = 'text-dark-orange bg-[rgba(234,102,63,0.2)]'; // Light red for high humidity
      if (range === 'NORMAL') rangeColor = 'text-dark-green bg-[rgba(89,209,206,0.2)]'; // Light green for normal
    }
  }

  return (
    <span className={cn(
      "px-1.5 py-1 paragraph-11 rounded bg-bg text-dark-grey font-inter",
      status === 'on' && !rangeColor && "text-primary bg-light-grey",
      status === 'off' && !rangeColor && "text-[#B4B4B4] bg-[#F0F0F0]",
      isAlarm && "text-black-orange bg-[#F4CEC5]",
      rangeColor, // Apply range color if available
      className
    )} style={{ fontFamily: 'Inter, sans-serif !important' }}>
      {formattedValue}{unit}
    </span>
  );
}